import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { Sale } from '../models/sale.model';
import { SaleService } from '../services/sale.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionResolver implements Resolve<Sale> {
  // skipcq
  constructor(private _saleService: SaleService, private _loadingService: LoadingService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Sale> {
    const orderId = route.paramMap.get('orderId'); 
    if(this._saleService.selectedSale) {
      return of(this._saleService.selectedSale);
    } else {
      if (orderId) {
        this._loadingService.startLoading();
        return this._saleService.getTransactionByOrderId(orderId).pipe(
          tap((val) => {
            this._loadingService.stopLoading();
          }),
          catchError((e) => {
            this._loadingService.stopLoading();
            console.log(e);
            return of(null);
          })
        );
      }
  
      const transactionId = route.paramMap.get('transactionId');
      const registerId = route.paramMap.get('registerId');
      const storeId = route.paramMap.get('storeId');
      const transactionDate = route.paramMap.get('transactionDate');
      this._loadingService.startLoading();
      return this._saleService.getTransactionById(transactionId, registerId, storeId, transactionDate).pipe(
        tap((val) => {
          this._loadingService.stopLoading();
        }),
        catchError((e) => {
          this._loadingService.stopLoading();
          console.log(e);
          return of(null);
        })
      );
    }
  }
}
